{
  "errors": {
    "yourRoleDoesNotAllowThisAction": "Sua função não permite {action}",
    "yourRoleDoesNotAllowYouToPerformThisAction": "Sua função não permite que você execute esta ação",
    "mustHaveAtLeast8Characters": "Deve ter pelo menos 8 caracteres",
    "mustContainUpperCaseAndLowerCase": "Deve conter letras maiúsculas e minúsculas",
    "mustContainAtLeastOneLetter": "Deve conter pelo menos uma letra",
    "mustContainAtLeastOneSpecialCharacter": "Deve conter pelo menos um caractere especial",
    "mustContainAtLeastOneNumber": "Deve conter pelo menos um número"
  },
  "descriptions": {
    "allPermissionsAndFullControlOverAllAccounts": "Todas as permissões e controle total sobre todas as contas.",
    "godRoleWithLessControl": "Função GOD com menos controle.",
    "allPermissionsAndFullControlOverTheOrganizationAccount": "Todas as permissões e controle total sobre a conta da organização.",
    "createEditDeleteAppointmentsWarehousesLoadTypesDocksAndUsersExceptOwners": "Criar/editar/excluir Agendamentos, Armazéns, Tipos de Carga, Docas e Usuários (exceto Proprietários).",
    "createEditCancelAppointments": "Criar/editar/cancelar Agendamentos.",
    "editAppointmentStatusTagsAndSubscribers": "Editar o status do agendamento, tags e assinantes.",
    "viewOnlyNoCreateOrEditActionsAllowed": "Apenas visualização. Nenhuma ação de criação ou edição permitida.",
    "carrierAdministrator": "Administrador da transportadora.",
    "carrierUser": "Usuário da transportadora",
    "baseUserAccount": "Conta de usuário básica.",
    "warehouseDriverHasLimitedAccessToTheApplication": "Motorista de armazém, tem acesso limitado à aplicação."
  }
}
